"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mapCategoryBarFromPageNavigation = void 0;
const mapCategoryBarFromPageNavigation = (categoryBarData)=>{
    if (!(categoryBarData === null || categoryBarData === void 0 ? void 0 : categoryBarData.items)) {
        return null;
    }
    const { pageId, items } = categoryBarData;
    const links = items.map((item)=>{
        var _item_itemId, _item_label, _item_url;
        return {
            id: (_item_itemId = item === null || item === void 0 ? void 0 : item.itemId) !== null && _item_itemId !== void 0 ? _item_itemId : '',
            title: (_item_label = item === null || item === void 0 ? void 0 : item.label) !== null && _item_label !== void 0 ? _item_label : '',
            relativeUrl: (_item_url = item === null || item === void 0 ? void 0 : item.url) !== null && _item_url !== void 0 ? _item_url : ''
        };
    });
    var _pageId_split_filter_length;
    const level = (_pageId_split_filter_length = pageId === null || pageId === void 0 ? void 0 : pageId.split('/').filter(Boolean).length) !== null && _pageId_split_filter_length !== void 0 ? _pageId_split_filter_length : 0;
    return {
        links,
        // Active link only on the 3 and above levels. Example - skincare/treatments/facial-oil/xxx
        active: level > 2 && pageId ? links.find((link)=>link.relativeUrl.includes(pageId)) : undefined
    };
};
exports.mapCategoryBarFromPageNavigation = mapCategoryBarFromPageNavigation;
